import {
  blacklistedPages,
  EVENT_MODAL_CLOSED,
  EVENT_MODAL_INPUT_CLICKED,
  EVENT_MODAL_SUBMIT,
  NEWSLETTER_MODAL_ID,
} from 'shared/experiments/browser/newsletterModalCH/consts'
import mountNewsletterModalContainer from 'shared/experiments/components/NewsletterModal/mountNewsletterModalFormContainer'
import trackEvent from 'shared/experiments/utils/trackOptimizelyEvent'

export const NL_MODAL_CH_WAIT_TIME = 7000

const modalCloseEventHandler = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (
    !target.closest('.m-Modal__content') &&
    window.location.hash === `#${NEWSLETTER_MODAL_ID}`
  ) {
    trackEvent(EVENT_MODAL_CLOSED)
    window.location.hash = ''
  }
}

export const triggerNewsletterModal = () => {
  document.addEventListener('click', modalCloseEventHandler)

  setTimeout(async function () {
    window.location.hash = NEWSLETTER_MODAL_ID
    window.sessionStorage.setItem(NEWSLETTER_MODAL_ID, 'true')
    await mountNewsletterModalContainer()
    window._uxa = window._uxa || []
    window._uxa.push([
      'trackPageview',
      `${window.location.pathname}${window.location.hash.replace('#', '/__')}`,
    ])

    document
      .getElementById(NEWSLETTER_MODAL_ID)
      ?.addEventListener('click', (event: Event) => {
        const target = <HTMLElement>event.target
        if (target.closest('#submit')) {
          trackEvent(EVENT_MODAL_SUBMIT)
        }

        if (target.closest('#newsletterEmail')) {
          trackEvent(EVENT_MODAL_INPUT_CLICKED)
        }

        if (
          target.closest('[data-clientside-hook~="NewsletterModalCloser"]') ||
          target.closest('.m-Modal__backdrop')
        ) {
          trackEvent(EVENT_MODAL_CLOSED)
        }
      })
  }, NL_MODAL_CH_WAIT_TIME)
}

export const getIsSourceBlacklisted = (
  page: string,
  searchUrl: string | undefined
) => {
  if (
    !searchUrl ||
    searchUrl.includes('newsletter=ch') ||
    blacklistedPages.includes(page)
  )
    return true

  return (
    searchUrl.includes('adword=google/S_de-CH_Branded_Exact/Brand_exact') ||
    searchUrl.includes('adword=google/S_fr-CH_Branded_Exact/Brand_exact') ||
    searchUrl.includes('adword=google/S_de-CH_Branded/Gen_Shop-Apotheke')
  )
}
